module.exports = __webpack_public_path__ + "static/media/delivery-bike-white.412bc3f3.svg";